import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fffcfc' },
    '2': { value: '#fff7f7' },
    '3': { value: '#feebec' },
    '4': { value: '#ffdbdc' },
    '5': { value: '#ffcdce' },
    '6': { value: '#fdbdbe' },
    '7': { value: '#f4a9aa' },
    '8': { value: '#eb8e90' },
    '9': { value: '#e5484d' },
    '10': { value: '#dc3e42' },
    '11': { value: '#ce2c31' },
    '12': { value: '#641723' },
    a1: { value: '#ff000003' },
    a2: { value: '#ff000008' },
    a3: { value: '#f3000d14' },
    a4: { value: '#ff000824' },
    a5: { value: '#ff000632' },
    a6: { value: '#f8000442' },
    a7: { value: '#df000356' },
    a8: { value: '#d2000571' },
    a9: { value: '#db0007b7' },
    a10: { value: '#d10005c1' },
    a11: { value: '#c40006d3' },
    a12: { value: '#55000de8' },
  },
  dark: {
    '1': { value: '#191111' },
    '2': { value: '#201314' },
    '3': { value: '#3b1219' },
    '4': { value: '#500f1c' },
    '5': { value: '#611623' },
    '6': { value: '#72232d' },
    '7': { value: '#8c333a' },
    '8': { value: '#b54548' },
    '9': { value: '#e5484d' },
    '10': { value: '#ec5d5e' },
    '11': { value: '#ff9592' },
    '12': { value: '#ffd1d9' },
    a1: { value: '#f4121209' },
    a2: { value: '#f22f3e11' },
    a3: { value: '#ff173f2d' },
    a4: { value: '#fe0a3b44' },
    a5: { value: '#ff204756' },
    a6: { value: '#ff3e5668' },
    a7: { value: '#ff536184' },
    a8: { value: '#ff5d61b0' },
    a9: { value: '#fe4e54e4' },
    a10: { value: '#ff6465eb' },
    a11: { value: '#ff9592' },
    a12: { value: '#ffd1d9' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.red.light.1}', _dark: '{colors.red.dark.1}' } },
  '2': { value: { _light: '{colors.red.light.2}', _dark: '{colors.red.dark.2}' } },
  '3': { value: { _light: '{colors.red.light.3}', _dark: '{colors.red.dark.3}' } },
  '4': { value: { _light: '{colors.red.light.4}', _dark: '{colors.red.dark.4}' } },
  '5': { value: { _light: '{colors.red.light.5}', _dark: '{colors.red.dark.5}' } },
  '6': { value: { _light: '{colors.red.light.6}', _dark: '{colors.red.dark.6}' } },
  '7': { value: { _light: '{colors.red.light.7}', _dark: '{colors.red.dark.7}' } },
  '8': { value: { _light: '{colors.red.light.8}', _dark: '{colors.red.dark.8}' } },
  '9': { value: { _light: '{colors.red.light.9}', _dark: '{colors.red.dark.9}' } },
  '10': { value: { _light: '{colors.red.light.10}', _dark: '{colors.red.dark.10}' } },
  '11': { value: { _light: '{colors.red.light.11}', _dark: '{colors.red.dark.11}' } },
  '12': { value: { _light: '{colors.red.light.12}', _dark: '{colors.red.dark.12}' } },
  a1: { value: { _light: '{colors.red.light.a1}', _dark: '{colors.red.dark.a1}' } },
  a2: { value: { _light: '{colors.red.light.a2}', _dark: '{colors.red.dark.a2}' } },
  a3: { value: { _light: '{colors.red.light.a3}', _dark: '{colors.red.dark.a3}' } },
  a4: { value: { _light: '{colors.red.light.a4}', _dark: '{colors.red.dark.a4}' } },
  a5: { value: { _light: '{colors.red.light.a5}', _dark: '{colors.red.dark.a5}' } },
  a6: { value: { _light: '{colors.red.light.a6}', _dark: '{colors.red.dark.a6}' } },
  a7: { value: { _light: '{colors.red.light.a7}', _dark: '{colors.red.dark.a7}' } },
  a8: { value: { _light: '{colors.red.light.a8}', _dark: '{colors.red.dark.a8}' } },
  a9: { value: { _light: '{colors.red.light.a9}', _dark: '{colors.red.dark.a9}' } },
  a10: { value: { _light: '{colors.red.light.a10}', _dark: '{colors.red.dark.a10}' } },
  a11: { value: { _light: '{colors.red.light.a11}', _dark: '{colors.red.dark.a11}' } },
  a12: { value: { _light: '{colors.red.light.a12}', _dark: '{colors.red.dark.a12}' } },
  default: { value: { _light: '{colors.red.light.9}', _dark: '{colors.red.dark.9}' } },
  emphasized: { value: { _light: '{colors.red.light.10}', _dark: '{colors.red.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.red.light.a11}', _dark: '{colors.red.dark.a11}' } },
})

export default {
  name: 'red',
  tokens,
  semanticTokens,
}
